import * as React from "react";
import DashBoardDataService from "../Service/DataService";
import DashboardIcons from "../DashboardIcons";
import { downloadExcel, getFileNameWithDate, history, successToastr } from "../../../HelperMethods";
import { getIconWithColor, toolTip } from "../GlobalActions";
import { KPI_Details } from "../../Shared/ApiUrls";
import { tileLayoutShimmerEffect } from "../../ReusableComponents";
import { TileLayout } from "@progress/kendo-react-layout";
import { DashboardDropDownFilter, DashboardDropDownFilterIds, DashboardDropDownFilterValues, DashboardHandleAction, EntityType, KPICategory, PersistenceData } from "../../Shared/AppConstants";
import { IDropDownModel } from "../../Shared/Models/IDropDownModel";
import withValueField from "../../Shared/withValueField";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import ActionIcon from "../ActionIcon";
import { EXCEL_DOWNLOAD_INPROGRESS, KPI_SAVED_SUCCESS_MSG } from "../../Shared/AppMessages";
import { toODataString } from "@progress/kendo-data-query";

const CustomDropDownList = withValueField(DropDownList);

export interface KPIProps { }

export interface KPIState {
    showLoader?: boolean;
    kpiOneData?: any;
    kpiTwoData?: any;
    activeItemIndex?: any;
    firstLoad?: boolean;
    isReorderable: boolean;
    filter?: Array<IDropDownModel>;
    filterId?: string;
    filterValue?: string;
    positionOne?: any;
    originalPositionOneData?: any;
    positionTwo?: any;
    originalPositionTwoData?: any;
    dashboardVitalsUserMapOneId?: string;
    dashboardVitalsUserMapTwoId?: string;
    kpiId?: any;
}

class KPI extends React.Component<KPIProps, KPIState> {
    activeItem;
    kpiOneTiles: [];
    kpiTwoTiles: [];
    constructor(props: KPIProps) {
        super(props);
        this.state = {
            showLoader: true,
            kpiOneData: [],
            kpiTwoData: [],
            firstLoad: true,
            isReorderable: false,
            filter: DashboardDropDownFilter,
            filterId: DashboardDropDownFilterIds.YEARTODATE,
            filterValue: DashboardDropDownFilterValues.YEARTODATE
        };
    }

    componentDidMount() {
        let searchData = JSON.parse(localStorage.getItem(`${PersistenceData.WORKFLOWMATRIXKPI}`))
        if (searchData && searchData.filterValue != "undefined") {
            this.setState({
                filterId : searchData.filterId,
                filterValue :searchData.filterValue
            })
            this.getKpis(searchData.filterValue);
        }
        else{
            this.getKpis(this.state.filterValue);
        }
    }

    getKpisOne = () => {
        DashBoardDataService.getKPIs(KPICategory.One, null).then((res) => {
            let posData = this.getPositionData(res.data);
            this.setState({
                kpiOneData: res.data,
                firstLoad: false,
                positionOne: posData,
                originalPositionOneData: posData,
                dashboardVitalsUserMapOneId: res.data[0]?.dashboardVitalsUserMapId
            });
        });
    }

    getKpisTwo = (filterValue) => {
        DashBoardDataService.getKPIs(KPICategory.Two, filterValue).then((res) => {
            let posData = this.getPositionData(res.data);
            this.setState({
                kpiTwoData: res.data,
                showLoader: false,
                positionTwo: posData,
                originalPositionTwoData: posData,
                dashboardVitalsUserMapTwoId: res.data[0]?.dashboardVitalsUserMapId
            });
        });
    }

    getKpis = (filterValue) => {
        this.getKpisOne();
        this.getKpisTwo(filterValue);
    };

    handleFilterChange = (e) => {
        const id = e.value.id;
        const value = e.value.value;
        let posData = Array.from({ length: 6 }).map((item, j) => {
            return {
                col: 1,
                rowSpan: 1,
                colSpan: 2
            }
        });
        this.setState({ filterId: id, filterValue: value, showLoader: true, positionTwo: posData}, () => { this.getKpisTwo(value); });
 
        var searchData = {}
        searchData = {
            'filterValue': value, 
            'filterId' : id
          }
        localStorage[`${PersistenceData.WORKFLOWMATRIXKPI}`] = JSON.stringify(searchData)

    }

    handleClick = async (action?) => {
        const { originalPositionOneData, originalPositionTwoData, isReorderable } = this.state;
        if (action === DashboardHandleAction.SAVE) {
            this.handleSave();
        } else if (action === DashboardHandleAction.CANCEL) {
            this.setState({ positionOne: originalPositionOneData, positionTwo: originalPositionTwoData });
        }
        this.setState({ isReorderable: !isReorderable });
    }

    handleSave = () => {
        const { positionOne, positionTwo, dashboardVitalsUserMapOneId, dashboardVitalsUserMapTwoId } = this.state;
        let dataOne = {
            entityType: EntityType.REQMATRIXKPI,
            recordSequence: JSON.stringify(positionOne)
        };

        let dataTwo = {
            entityType: EntityType.WFMATRIXKPI,
            recordSequence: JSON.stringify(positionTwo)
        };

        let isTaskOneCompleted = false;
        let isTaskTwoCompleted = false;

        if (dashboardVitalsUserMapOneId == null || dashboardVitalsUserMapOneId === undefined) {
            DashBoardDataService.postSequence(dataOne).then((res) => {
                isTaskOneCompleted = true;
                if (isTaskOneCompleted && isTaskTwoCompleted) {
                    successToastr(KPI_SAVED_SUCCESS_MSG);
                }
                this.setState({ originalPositionOneData: positionOne });
            });
        } else {
            DashBoardDataService.putSequence(dashboardVitalsUserMapOneId, dataOne).then((res) => {
                isTaskOneCompleted = true;
                if (isTaskOneCompleted && isTaskTwoCompleted) {
                    successToastr(KPI_SAVED_SUCCESS_MSG);
                }
                this.setState({ originalPositionOneData: positionOne });
            });
        }

        if (dashboardVitalsUserMapTwoId == null || dashboardVitalsUserMapTwoId === undefined) {
            DashBoardDataService.postSequence(dataTwo).then((res) => {
                isTaskTwoCompleted = true;
                if (isTaskOneCompleted && isTaskTwoCompleted) {
                    successToastr(KPI_SAVED_SUCCESS_MSG);
                }
                this.setState({ originalPositionTwoData: positionTwo });
            });
        } else {
            DashBoardDataService.putSequence(dashboardVitalsUserMapTwoId, dataTwo).then((res) => {
                isTaskTwoCompleted = true;
                if (isTaskOneCompleted && isTaskTwoCompleted) {
                    successToastr(KPI_SAVED_SUCCESS_MSG);
                }
                this.setState({ originalPositionTwoData: positionTwo });
            });
        }
    }

    getPositionData = (data) => {
        return data.map((kpi, i) => {
            let data = {
                order: i + 1,
                kpiId: kpi.kpiId,
            }
            return data;
        })
    }

    kpiData = ({ name, value, icon, kpiCode, description, kpiId, kpiCategoryIntId }) => (
        <div className="card mx-0 p-3 shadow-sm card-radius mb-1">
            {toolTip(
                <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between mb-2">
                        <h3 title={description} className='heading3 d-inline-block d-flex align-items-center justify-content-start mb-0'>
                            {getIconWithColor(icon)}
                            {name}</h3>
                        <span className='largText'>
                            <span title={value}>{value}</span>
                        </span>
                    </div>

                    {!this.state.isReorderable ?
                        <div className="col-12 text-rightcol-12 text-right d-flex align-items-center justify-content-end mt-1">
                            <button
                                className='btn-transp icon-center mr-3 icon-squire'
                                title="Export"
                                id={`${kpiId}_export`}
                                onClick={() => this.downloadKPIExcel(name, kpiCode, kpiId, this.state.filterValue)}
                            > <img className='normal-icon' src={DashboardIcons.downloadIcon} />
                                <img className='hover-icon' src={DashboardIcons.downloadIconHover} />
                            </button>

                            <button
                                className='btn-transp icon-center icon-squire'
                                title="View"
                                id={`${kpiId}_view`}
                                onClick={() => history.push(this.kpiDetailsUrl(kpiCode, kpiId, kpiCategoryIntId))}>
                                <img className='normal-icon' src={DashboardIcons.rightArrowIcon} />
                                <img className='hover-icon' src={DashboardIcons.rightArrowIconHover} />
                            </button>
                        </div>
                        :
                        <div className="col-12 text-rightcol-12 text-right d-flex align-items-center justify-content-end mt-3">
                            <button className='btn-transp icon-center px-2'>

                                <img height={8} width={12} src={DashboardIcons.shuffleIcon} />
                            </button>
                        </div>
                    }

                </div>
            )}
        </div>
    )

    private kpiDetailsUrl(kpiCode: any, kpiId: any, kpiCategoryIntId: any) {
        return this.state.filter && kpiCategoryIntId == KPICategory.Two ? `${KPI_Details}/${kpiId}/${this.state.filterValue}/${kpiCode}` : `${KPI_Details}/${kpiId}/${kpiCode}`;
    }

    downloadKPIExcel = (fileName, kpiCode, kpiId, filterType) => {
        var dataState = {
            take: null,
            skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        var queryStr = `${toODataString(dataState)}`;
        DashBoardDataService.getKpiExcel(kpiId, filterType, kpiCode, queryStr).then((res: any) => {
            if (res) {
                downloadExcel(`${getFileNameWithDate(fileName)}.xlsx`, res.data);
            }
        });
    }

    render() {
        const { kpiOneData, kpiTwoData, firstLoad, isReorderable, showLoader } = this.state;

        this.kpiOneTiles = kpiOneData && kpiOneData.length === 0 && !firstLoad ? [] :
            kpiOneData && kpiOneData.length && !firstLoad ? this.kpiDataMappper(kpiOneData)
                : firstLoad && this.kpiShimmer()

        this.kpiTwoTiles = kpiTwoData && kpiTwoData.length === 0 && !showLoader ? [] :
            kpiTwoData && kpiTwoData.length && !showLoader ? this.kpiDataMappper(kpiTwoData)
                : showLoader && this.kpiShimmer()
        return (
            <div>
                <div className='card card-radius py-4 pl-4 pr-2 mb-23'>
                    <div className='d-flex align-items-center justify-content-between mb-3 pr-3'>
                        <h2 className='heading2 text-right mb-0 text-green'>{this.getKpiCategory(kpiOneData)} </h2>
                        <ActionIcon
                            firstLoad={firstLoad}
                            isReorderable={isReorderable}
                            handleClick={this.handleClick}
                        />
                    </div>
                    <div className={'col-12 px-0 mb-3 card-overflow pr-2' + (!isReorderable ? ' noEdit' : '')}>
                        {this.kpiOneTiles && this.kpiOneTiles.length > 0 &&
                            <TileLayout
                                rowHeight={150}
                                columnWidth={10}
                                items={this.kpiOneTiles}
                                ignoreDrag={() => !isReorderable}
                                positions={this.state.positionOne}
                                onReposition={(e) => this.setState({ positionOne: e.value })}
                            />}
                    </div>

                    {/* Workforce Metrics */}
                    <div className='d-flex align-items-center justify-content-between mb-3 pr-3'>
                        <h2 className='heading2 text-right text-blue'> {this.getKpiCategory(kpiTwoData)}</h2>
                        <div className='d-flex'>
                            {!isReorderable &&
                                <CustomDropDownList
                                    className={"kpi-input-control month-to-date"}
                                    data={this.state.filter}
                                    name="name"
                                    textField="name"
                                    valueField="id"
                                    id="filter"
                                    value={this.state.filterId}
                                    onChange={(e) => this.handleFilterChange(e)}
                                />
                            }
                        </div>
                    </div>
                    <div className={'col-12 px-0 mb-3 card-overflow pr-2' + (!isReorderable ? ' noEdit' : '')}>
                        {this.kpiTwoTiles && this.kpiTwoTiles.length > 0 &&
                            <TileLayout
                                rowHeight={150}
                                columnWidth={10}
                                items={this.kpiTwoTiles}
                                ignoreDrag={() => !isReorderable}
                                positions={this.state.positionTwo}
                                onReposition={(e) => this.setState({ positionTwo: e.value })}
                            />}
                    </div>
                </div>
            </div>
        )
    }

    private getKpiCategory(kpiOneData: any): string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal {
        return kpiOneData && kpiOneData.length > 0 && kpiOneData[0].kpiCategory;
    }

    private kpiShimmer() {
        return Array.from({ length: 6 }).map((item, j) => {
            return tileLayoutShimmerEffect();
        });
    }

    private kpiDataMappper(kpiRecords: any) {
        return kpiRecords.map((kpi, i) => {
            let data = {
                item: this.kpiData(kpi),
                resizable: false
            };
            return data;
        });
    }
}

export default KPI;